<div class="modal-header border-0 p-4">
  <div class="header-content d-flex align-items-center justify-content-center w-100">
    <div class="header-icon-container me-3">
      <i class="fas fa-gavel text-white fs-4"></i>
    </div>
    <h4 class="modal-title text-white mb-0">Canal de Denuncias</h4>
  </div>
  <button
    type="button"
    class="btn-close btn-close-white position-absolute end-0 top-0 m-3"
    (click)="activeModal.dismiss()"
  ></button>
</div>

<div class="modal-body p-4">
  <p class="text-center instruction-text mb-4">
    Utilice el siguiente formulario para reportar de forma confidencial cualquier irregularidad o
    conducta inapropiada
  </p>

  <div class="complaint-card-container">
    <form [formGroup]="complaintForm" (ngSubmit)="onSubmit()" class="p-4">
      <div class="section-title mb-3">
        <h6 class="fw-bold text-dark border-bottom pb-2">Detalle de la denuncia</h6>
        <a
          href="/hoja_de_reclamaciones_ver_nov18_0.pdf"
          download="Hoja_de_Reclamaciones.pdf"
          class="btn btn-outline-light btn-sm ms-1 align-items-start"
          target="_blank"
        >
          <i class="fas fa-file-download me-2"></i>Descargar Hoja de Reclamaciones
        </a>
      </div>

      <!-- Tipo de denuncia -->
      <div class="mb-3">
        <label class="form-label small fw-bold">Tipo de Denuncia</label>
        <select
          class="form-select custom-select"
          formControlName="complaintType"
          [ngClass]="{
            'is-invalid':
              complaintForm.get('complaintType')?.touched &&
              complaintForm.get('complaintType')?.errors,
          }"
        >
          <option value="" disabled selected>Seleccione</option>
          <option [value]="1">Fraude</option>
          <option [value]="2">Corrupción</option>
          <option [value]="3">Uso indebido de información o datos</option>
          <option [value]="4">Conflicto de intereses</option>
          <option [value]="5">Acoso laboral o conducta inapropiada</option>
          <option [value]="6">Discriminación</option>
          <option [value]="7">Incumplimiento de políticas internas</option>
          <option [value]="8">Irregularidades financieras</option>
          <option [value]="9">Abuso de autoridad</option>
          <option [value]="10">Otro</option>
        </select>
        <div class="invalid-feedback">Este campo es requerido.</div>
      </div>

      <!-- Descripción -->
      <div class="mb-3">
        <label class="form-label small fw-bold">Descripción del hecho</label>
        <textarea
          class="form-control"
          rows="4"
          formControlName="description"
          placeholder="Describa detalladamente el hecho: que ocurrio, como ocurrio y a quien involucra"
          [ngClass]="{
            'is-invalid':
              complaintForm.get('description')?.touched && complaintForm.get('description')?.errors,
          }"
        ></textarea>
        <div class="invalid-feedback">Debe proporcionar una descripción detallada.</div>
      </div>

      <div class="row mb-3">
        <!-- Fecha -->
        <div class="col-md-6 mb-3">
          <label class="form-label small fw-bold">Fecha aproximada del hecho</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="DD/MM/AAAA"
              formControlName="incidentDate"
              mwlFlatpickr
              [flatpickrOptions]="{ altInput: true, altFormat: 'd/m/y', dateFormat: 'Y-m-d' }"
              [ngClass]="{
                'is-invalid':
                  complaintForm.get('incidentDate')?.touched &&
                  complaintForm.get('incidentDate')?.errors,
              }"
            />
            <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
          </div>
          <div
            class="invalid-feedback d-block"
            *ngIf="
              complaintForm.get('incidentDate')?.touched &&
              complaintForm.get('incidentDate')?.errors
            "
          >
            Fecha requerida.
          </div>
        </div>

        <!-- Adjuntar archivos -->
        <div class="col-md-6 mb-3">
          <label class="form-label small fw-bold d-block">Adjuntar archivos (opcional)</label>
          <div class="upload-container d-flex align-items-center">
            <label for="fileInput" class="btn btn-attach mb-0 me-2" title="Adjuntar archivo">
              <i class="fas fa-upload"></i>
            </label>
            <input
              type="file"
              id="fileInput"
              class="file-input"
              (change)="onFileSelected($event)"
              accept=".pdf,.jpg,.jpeg,.png,.svg,.docx"
              hidden
            />
            <div *ngIf="complaintFile" class="file-badge d-flex align-items-center">
              <span class="file-name text-truncate" [title]="complaintFile.name">
                {{ complaintFile.name }}
              </span>
              <button type="button" class="btn-remove-file ms-1" (click)="removeFile()">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <span *ngIf="!complaintFile && !fileError" class="text-muted small">Sin archivo</span>
          </div>
          <div *ngIf="fileError" class="text-danger small mt-1">
            {{ fileError }}
          </div>
          <div class="file-hints mt-1">
            <small class="text-muted d-block text-justify">Peso máximo: 5MB</small>
            <small class="text-muted d-block text-justify"
              >Formatos: pdf, jpg, png, svg o docx</small
            >
          </div>
        </div>
      </div>

      <!-- Opciones adicionales -->
      <div class="row align-items-center mb-4">
        <div class="col-12">
          <div class="d-flex align-items-center">
            <input
              class="form-check-input mt-0"
              type="checkbox"
              id="anonCheck"
              formControlName="isAnonymous"
            />
            <label class="form-check-label small ms-2" for="anonCheck">
              ¿Desea realizar la denuncia de forma anónima?
            </label>
          </div>
        </div>
      </div>

      <div class="section-title mb-3">
        <h6 class="fw-bold text-dark border-bottom pb-2">
          Datos de contacto <span class="text-muted fw-normal small">(Opcional)</span>
        </h6>
      </div>

      <div *ngIf="!complaintForm.get('isAnonymous')?.value">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label small fw-bold">Nombre Completo</label>
            <input
              type="text"
              class="form-control"
              formControlName="contactName"
              placeholder="Nombre"
              [ngClass]="{
                'is-invalid':
                  complaintForm.get('contactName')?.touched &&
                  complaintForm.get('contactName')?.errors,
              }"
            />
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label small fw-bold">Correo Electrónico</label>
            <input
              type="email"
              class="form-control"
              formControlName="contactEmail"
              placeholder="Correo electrónico"
              [ngClass]="{
                'is-invalid':
                  complaintForm.get('contactEmail')?.touched &&
                  complaintForm.get('contactEmail')?.errors,
              }"
            />
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label small fw-bold">Teléfono</label>
          <input
            type="text"
            class="form-control"
            formControlName="contactPhone"
            placeholder="Teléfono"
            (input)="onPhoneInput($event)"
            [ngClass]="{
              'is-invalid':
                complaintForm.get('contactPhone')?.touched &&
                complaintForm.get('contactPhone')?.errors,
            }"
          />
          <div class="invalid-feedback">Ingrese un número válido (solo números, + y -).</div>
        </div>
      </div>

      <!-- Footer de información -->
      <div class="info-footer-container mt-3 mb-4">
        <p class="info-footer-text mb-0" [class.expanded]="showFullPolicy">
          En cumplimiento del Reglamento General de Protección de Datos (UE) 2016/679 del Parlamento
          Europeo y del Consejo de 27 de abril de 2016 y la ley orgánica 3/2018 de 5 de diciembre de
          Protección de Datos Personales y de Garantía de los Derechos Digitales le informamos que
          los datos por Vd. proporcionados serán objeto de tratamiento por parte de ARCADIA VIAJES
          INOLVIDABLES SL con CIF B19835412, con domicilio en MADRID (MADRID), C.P. 28007 , AV.
          MENENDEZ PELAYO 38, BAJO C , con la finalidad de prestarle el servicio solicitado y/o
          contratado, realizar la facturación del mismo. La base legal para el tratamiento de sus
          datos es la ejecución del servicio por usted contratado y/o solicitado. La oferta
          prospectiva de productos y servicios está basada en el consentimiento que se le solicita,
          sin que en ningún caso la retirada de este consentimiento condicione la ejecución del
          contrato. Los datos proporcionados se conservarán mientras se mantenga la relación
          comercial o durante los años necesarios para cumplir con las obligaciones legales. Los
          datos no se cederán a terceros salvo en los casos en que exista una obligación legal.
          Usted tiene derecho a obtener confirmación sobre si en ARCADIA VIAJES INOLVIDABLES SL
          estamos tratando sus datos personales y por tanto tiene derecho a ejercer sus derechos de
          acceso, rectificación, limitación del tratamiento, portabilidad, oposición al tratamiento
          y supresión de sus datos mediante escrito dirigido a la dirección postal arriba mencionada
          o electrónica brayanjosetorresrugeles@gmail.com, adjuntando copia del DNI en ambos casos,
          así como el derecho a presentar una reclamación ante la Autoridad de Control (aepd.es).
        </p>
        <div class="text-end">
          <button type="button" class="btn btn-link btn-show-more p-0" (click)="toggleFullPolicy()">
            {{ showFullPolicy ? 'Ver menos' : 'Ver más...' }}
          </button>
        </div>
      </div>

      <!-- Mensajes de éxito/error -->
      <div *ngIf="successMsg" class="alert alert-success mt-3 text-center">
        {{ successMsg }}
      </div>
      <div *ngIf="errorMsg" class="alert alert-danger mt-3 text-center">
        {{ errorMsg }}
      </div>

      <!-- Botón enviar -->
      <div class="d-flex justify-content-center">
        <button
          type="submit"
          class="btn btn-submit-complaint px-5 py-2"
          [disabled]="isSubmitting || complaintForm.invalid || fileError"
        >
          <span
            *ngIf="isSubmitting"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          {{ isSubmitting ? 'Enviando...' : 'Enviar Denuncia' }}
        </button>
      </div>
    </form>
  </div>
</div>
